export const isAddressComplete = (address = {}) => {
  const countryCode = (address.countryCode || '').trim();
  const hasState = countryCode !== 'US' || Boolean((address.state || '').trim());

  return Boolean(
    (address.street || '').trim()
    && (address.city || '').trim()
    && (address.zipCode || '').trim()
    && countryCode
    && hasState
  );
};
